export default __webpack_public_path__ + "fonts/iot_4.65d4191b86ce051df080e56cc5b31685.png";